<template>

    <div>

        <div class="border border-gray-300 px-3 py-3 mb-2 rounded">
            <div class="flex justify-between items-center">
                <CardRadio name="paymentMethod" v-model="method" checked-value="stripe-payment-intent">Kontokort</CardRadio>
                <div class="mr-8">
                    <img class="inline mr-2":srcset="`${publicPath}/images/payments/visa@2x.png 2x`" :src="`${publicPath}/images/payments/visa.png`" alt="Visa">
                    <img class="inline" :srcset="`${publicPath}/images/payments/mastercard@2x.png 2x`" :src="`${publicPath}/images/payments/mastercard.png`" alt="Mastercard">
                </div>
            </div>
            <OrangePaymentStripePaymentIntent
                :api="api"
                :name="name"
                :order-id="orderId"
                :method="method"

                @success="success"
            ></OrangePaymentStripePaymentIntent>

        </div>

        <div class="border border-gray-300 px-3 py-3 rounded mb-2">
            <div class="flex justify-between items-center">
                <CardRadio name="paymentMethod" v-model="method" checked-value="swish">Swish</CardRadio>
                <div class="mr-8">
                    <img :srcset="`${publicPath}/images/payments/swish@2x.png 2x`" :src="`${publicPath}/images/payments/swish.png`" alt="Swish">
                </div>
            </div>

            <orange-payment-swish
                :api="api"
                :name="name"
                :order-id="orderId"
                :method="method"

                @success="success"
            >
            </orange-payment-swish>
        </div>

        <div class="border border-gray-300 px-3 py-3 rounded mb-2">
            <div class="flex justify-between items-center">
                <CardRadio name="paymentMethod" v-model="method" checked-value="trustly">Banköverföring</CardRadio>
                <div class="mr-8">
                    <img :srcset="`${publicPath}/images/payments/trustly@2x.png 2x`" :src="`${publicPath}/images/payments/trustly.png`" alt="Bank">
                </div>
            </div>

            <orange-payment-trustly
                :api="api"
                :name="name"
                :order-id="orderId"
                :method="method"
                :success-url="successUrl"
            >
            </orange-payment-trustly>
        </div>

        <div class="border border-gray-300 px-3 py-3 rounded">
            <div class="flex justify-between items-center">
                <CardRadio name="paymentMethod" v-model="method" checked-value="bankgirot">Bankgiro/Plusgiro</CardRadio>
                <div class="mr-8">
                    <img :srcset="`${publicPath}/images/payments/bankgirot@2x.png 2x`" :src="`${publicPath}/images/payments/bankgirot.png`" alt="Bankgirot">
                </div>
            </div>

            <orange-payment-bankgirot
                :api="api"
                :name="name"
                :order-id="orderId"
                :method="method"

                @success="success"
            ></orange-payment-bankgirot>
        </div>

    </div>

</template>

<script>
    import CardRadio from "./CardRadio";
    import CardInput from "./CardInput";
    import OrangePaymentStripePaymentIntent from "./OrangePaymentStripePaymentIntent";
    import OrangePaymentSwish from "./OrangePaymentSwish";
    import OrangePaymentTrustly from "./OrangePaymentTrustly";
    import OrangePaymentBankgirot from "./OrangePaymentBankgirot";

    export default {
        components: {OrangePaymentBankgirot, OrangePaymentTrustly, OrangePaymentSwish, OrangePaymentStripePaymentIntent, CardRadio, CardInput},
        props: ['api', 'name', 'orderId', 'successUrl'],
        data() {
            return {
                publicPath: process.env.VUE_APP_BASE_URL,
                method: null,

                swishPhoneNumber: null,
                waitingOnSwish: false,
            }
        },
        methods: {
            async payWithSwish() {
                this.waitingOnSwish = true
            },
            success() {
                this.$emit('success')
            }
        }
    }
</script>

<style type="text/css">
    .orange-payment-method-expanded {
        padding-top: 22px;
        padding-left: 28px;
        padding-right: 28px;
    }


    /* Stripe input */
    .orange-card-wrapper input,
    .orange-card-wrapper button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: none;
        border-style: none;
    }

    .orange-card-wrapper input:-webkit-autofill {
        -webkit-text-fill-color: #fce883;
        transition: background-color 100000000s;
        -webkit-animation: 1ms void-animation-out;
    }

    .orange-card-wrapper .StripeElement--webkit-autofill {
        background: transparent !important;
    }

    .orange-card-wrapper .StripeElement {
        width: 100%;
        padding: 11px 15px 11px 0;
    }

    .orange-card-wrapper input {
        width: 100%;
        padding: 11px 15px 11px 0;
        color: #fff;
        background-color: transparent;
        -webkit-animation: 1ms void-animation-out;
    }

    .orange-card-wrapper input::-webkit-input-placeholder {
        color: #87bbfd;
    }

    .orange-card-wrapper input::-moz-placeholder {
        color: #87bbfd;
    }

    .orange-card-wrapper input:-ms-input-placeholder {
        color: #87bbfd;
    }



    /* Spinner */
    .payment-spinner {
        width: 50px;
        text-align: center;
        margin: 0 auto;
    }

    .payment-spinner > div {
        width: 8px;
        height: 8px;
        background-color: #fff;
        margin-right: 4px;

        border-radius: 100%;
        display: inline-block;
        -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    }
    .payment-spinner.payment-spinner-blue > div {
        background-color: #1D5091;
    }

    .payment-spinner .payment-bounce1 {
        -webkit-animation-delay: -0.32s;
        animation-delay: -0.32s;
    }

    .payment-spinner .payment-bounce2 {
        -webkit-animation-delay: -0.16s;
        animation-delay: -0.16s;
    }

    @-webkit-keyframes sk-bouncedelay {
        0%, 80%, 100% { -webkit-transform: scale(0) }
        40% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bouncedelay {
        0%, 80%, 100% {
            -webkit-transform: scale(0);
            transform: scale(0);
        } 40% {
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
          }
    }
</style>